import { useSelector } from "react-redux";
import { formatCurrency } from "utils/format";

const FormatPrice = ({ code, price = 0 }) => {
  const companyState = useSelector((state) => state.companyReducer.company);
  return formatCurrency(price, code || companyState);
};

export default FormatPrice;
